export const levelsScoresColorData = 
[
   
    {
        minScore: 90,
        maxScore: 101,
        BColor: "linear-gradient(180deg, #2D8150 0%, #1C9471 100%)",
        color: "#2D8150",
        status: "Completed",
        ScoreThreshold: "100 - 90"
    },
    {
        minScore: 80,
        maxScore: 90,
        BColor: "linear-gradient(180deg, #6BD138 0%, #36A55B 100%)",
        color: "#6BD138",
        status: "Completed",
        ScoreThreshold: "90 - 80"
    },

    {
        minScore: 70,
        maxScore: 80,
        BColor: "#FFF500",
        color: "#EED65A",
        status: "Completed",
        ScoreThreshold: "80 - 70"

    },

    {
        minScore: 60,
        maxScore: 70,
        BColor: "linear-gradient(180deg, #F2AD24 0%, #F68E68 100%)",
        color: "#FEAC30",
        status: "Completed",
        ScoreThreshold: "70 - 60"
    },


    {
        minScore: -1,
        maxScore: 60,
        BColor: "#E63E3E",
        color: "#E63E3E",
        status: "Completed",
        ScoreThreshold: ">60"

    },
    {
        minScore: null,
        maxScore: null,
        BColor: "#6DE8EA",
        color: "#6DE8EA",
        status: "Started",
        ScoreThreshold: "startedWorkingAndHasNotSubmittedYet"
    },
    {
        minScore: null,
        maxScore: null,
        BColor: "#C4C4C4",
        color: "#6BD138",
        status: "Submitted",
        ScoreThreshold: "submittedAndNotYetGraded"
    },
    {
        minScore: null,
        maxScore: null,
        BColor: "#ffffff",
        color: "#ffffff",
        status: "NotStarted",
        ScoreThreshold: "studentNotStartedWorkingOnAssignment"
    }

]